export const MonitoringPlanConstant = {
    No_Data_Submitted:"No Data Submitted",
    SEEMP_II: "SEEMP II",
    SEEMP_III: "SEEMP III",
    FuelEU:"FEU MP",
    MRV:"EU MRV MP",
}